'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var getVastDurationInMillis = exports.getVastDurationInMillis = function getVastDurationInMillis(timeString) {
  var timeStr = timeString || '00:00:00';
  var arr = timeStr.split(':');
  var timeArr = arr.slice(0, 2).concat(arr[2].split('.')).map(parseFloat);
  var hours = timeArr[0];
  var minutes = timeArr[1];
  var seconds = timeArr[2];
  var milliseconds = timeArr.length > 3 ? timeArr[3] : 0;
  return hours * 60 * 60 * 1000 + minutes * 60 * 1000 + seconds * 1000 + milliseconds;
};
//# sourceMappingURL=duration.js.map


// WEBPACK FOOTER //
// ./src/helpers/duration.js